import BossModel from "@/models/BossModel";
import constants from "@/constants";

export default class Payment extends BossModel {

    static apiUrl = 'dossier/payment';

    static entity = 'payment';

    static fields() {
        return {
            id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            customer_id:this.number(null).nullable(),
            dossier_id: this.number(null).nullable(),
            reference: this.attr(null),
            description: this.attr(null),
            payment_method: this.attr(null),
            deposited_on: this.number(null).nullable(),
            contra_account: this.attr(null),
            amount: this.number(null).nullable(),
            icepay_payment_eid: this.attr(null),
            icepay_transaction_eid: this.attr(null),
            icepay_checksum: this.attr(null),
            icepay_verified_at: this.attr(null),
            icepay_verified_state: this.attr(null),
            worldline_payment_eid: this.attr(null),
            worldline_verified_at: this.attr(null),
            worldline_verified_state: this.attr(null),
            is_paid: this.boolean(null),
            paid_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    static loadByDossier(dossierId) {
        this.api()
            .where('dossier_id', dossierId)
            .where('is_paid', 1)
            .limit(0)
            .get(true);
    }

    save() {
        return this.constructor.api().create(this);
    }

    paymentMethod() {
        return constants.paymentMethods.find((method) => method.id === this.payment_method);
    }

    depositMethod() {
        return constants.depositMethods.find(method => method.id === this.deposited_on);
    }
}
